import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=2e89fc4a&scoped=true&"
import script from "./myList.vue?vue&type=script&lang=js&"
export * from "./myList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89fc4a",
  null
  
)

export default component.exports